import { helpers } from '@vuelidate/validators'

const passwordRegex = /^(?=.*[A-Z])(?=.*\d)[A-Za-z\d\S]{12,}$/

export const vuelidatePasswordPattern = helpers.regex(
  passwordRegex
)
